import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, output, Signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { User } from '@shared/graphql/generated';
import { CallbackModalStoreService } from '@shared/modals/callback-modal/shared/callback-modal-store.service';
import { CallbackType } from '@shared/modals/callback-modal/shared/callback-type';
import { NavLinkWithIcon } from '@shared/models/nav-link';
import { AuthModalService } from '@shared/services/auth-modal.service';
import { UserStoreService } from '@shared/stores/user-store.service';
import { AuthModalType } from '@shared/types/auth-modal-type';
import { AvatarPlaceholderComponent } from '@shared/ui-components/avatar-placeholder/avatar-placeholder.component';

@Component({
  selector: 'evland-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: [ './sidenav-menu.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    NgOptimizedImage,
    MatIcon,
    AvatarPlaceholderComponent
  ]
})
export class SidenavMenuComponent {
  onClose = output();
  navLinks: NavLinkWithIcon[] = [
    { href: '/catalog', label: $localize`Каталог`, icon: 'sax:bulk-car' },
    { href: '/warehouse', label: $localize`В наявності`, icon: 'sax:bulk-shop' },
    { href: '/offers', label: $localize`З пробігом`, icon: 'sax:bulk-discount-shape' },
    { href: '/reviews', label: $localize`Відгуки`, icon: 'sax:bulk-message', badge: 'NEW' },
    { href: '/financing', label: $localize`Фінансування`, icon: 'sax:bulk-wallet-3' },
    { href: '/euro-charge', label: $localize`EuroCharge™`, icon: 'sax:bulk-flash' },
    { href: '/zeekr-check', label: $localize`Перевірка ZEEKR`, icon: 'sax:bulk-car' },
    { href: '/about-us', label: $localize`Про нас`, icon: 'sax:bulk-book' },
    { href: '/contact-us', label: $localize`Контакти`, icon: 'sax:bulk-call' },
  ];
  currentUser: Signal<User>;
  fullName: Signal<string>;

  private authModal = inject(AuthModalService);
  private callbackModal = inject(CallbackModalStoreService);
  private router = inject(Router);
  private userStore = inject(UserStoreService);

  constructor() {
    this.initSignals();
  }

  close(): void {
    this.onClose.emit();
  }

  onAuthBlockClick(): void {
    if (!this.currentUser()) return;

    this.router.navigate([ '/account' ]);
    this.close();
  }

  openCallbackModal(): void {
    this.close();
    this.callbackModal.show({
      type: CallbackType.Consultation,
      title: $localize`Замовити консультацію`,
      action_label: $localize`Замовити`,
      subject: $localize`Консультація`,
    });
  }

  openAuthModal(event: Event, type: AuthModalType): void {
    event.preventDefault();
    event.stopPropagation();

    this.authModal.show(type);
  }

  private initSignals(): void {
    this.currentUser = this.userStore.currentS;
    this.fullName = computed(() => {
      const user = this.currentUser();

      if (!user) return null;

      return [ user.last_name, user.first_name, user.middle_name ].filter(Boolean).join(' ');
    });
  }
}
